import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

// Components
import LocationMap from '../LocationMap/LocationMap';
import LocationList from '../LocationList/LocationList';
import TabSwitch, { Tab } from '../TabSwitch/TabSwitch';
import Spinner from '../Spinner/Spinner';

// Context
import { LocationContext } from '../LocationContext/LocationContext';

// Tab Icons
import TabMapIcon from '../../assets/images/icons/TabMapIcon';
import TabListIcon from '../../assets/images/icons/TabListIcon';

// Styles
import styles from './LocationIndex.module.scss';

const LocationIndex = ({ locale }) => {
    const {
        setCurrentView,
        loadingState,
        errorMessage,
    } = useContext(LocationContext);

    const infoLine = () => {

        if (loadingState === 'error' && errorMessage !== '') {

            return (
                <div>
                    {errorMessage}
                </div>
            );
        }

        return (<></>);
    };

    const infoLineDOM = (
        <div className={styles.infoLine}>
            {loadingState === 'loading' || loadingState === 'initial' ? <Spinner />
                : infoLine()}
        </div>
    );

    return (
        <div
            data-pi-locale={locale}
            className="schulerLocationMap"
            data-pi-component="LocationIndex"
        >
            <main>
                <TabSwitch
                    onChange={(key) => {
                        setCurrentView(key);
                    }}
                    infoLine={infoLineDOM}
                >
                    <Tab
                        title={i18n.t('tabSwitch.tab.map')}
                        icon={<TabMapIcon />}
                        name="map"
                    >
                        <LocationMap initialZoomLevel={5} />
                    </Tab>
                    <Tab
                        title={i18n.t('tabSwitch.tab.list')}
                        icon={<TabListIcon />}
                        name="list"
                    >
                        <LocationList />
                    </Tab>
                </TabSwitch>
            </main>
        </div>
    );
};
LocationIndex.propTypes = {
    locale: PropTypes.string,
};

export default LocationIndex;
